import { render, staticRenderFns } from "./FHIRClientDetail.vue?vue&type=template&id=7f063794&"
import script from "./FHIRClientDetail.vue?vue&type=script&lang=ts&"
export * from "./FHIRClientDetail.vue?vue&type=script&lang=ts&"
import style0 from "./FHIRClientDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FHIRClientDetail.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports